import React, { FunctionComponent } from "react";

import { Icon, Text, TextProps } from "@multiweb/reactComponents";
import { bemClassNames } from "@multiweb/reactUtils";
import { IconCode } from "@multiweb/types/contracts";

const classNames = bemClassNames("dropdown-icon-text");

export type DropdownIconTextProps = {
    /** Kód ikony k zobrazení */
    iconCode?: IconCode;
} & Pick<TextProps, "value" | "disabled" | "ellipsis">;

export const DropdownIconText: FunctionComponent<DropdownIconTextProps> = (({
    disabled,
    value,
    iconCode,
    ellipsis = true,
}) => {
    return (
        <div className={classNames()}>
            <div className={classNames("icon")}>
                {iconCode && <Icon disabled={disabled} iconCode={iconCode} />}
            </div>
            {value && <div className={classNames("text")}>
                <Text isTextSelectable={false} {...{ disabled, value, ellipsis }} />
            </div>}
        </div>);
});
